<template>
  <div class="cusHeader"  v-loading="loading" style="height:calc(90vh - 140px);overflow: auto; position: relative;">
    <div class="headerList" >
      <div class="headerList-title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-diandeng"></use>
        </svg>
        <p>{{ $t('sumRemark') }}</p>
      </div>
      <div class="headerList-box">
        <draggable
          class="list-group"
          :list="headerList"
          group="tableHeader"
          @change="add"
        >
          <div class="header-item" v-for="(element,index) in headerList"  :key="element.id">
            {{element[getTitleCust] ? element[getTitleCust] : element.itemName}}<svg class="icon" aria-hidden="true" @click="deleteList(index,element)" style="font-size: 12px">
            <use xlink:href="#icon-shanchu"></use>
          </svg>
          </div>
        </draggable>
      </div>
    </div>
    <div class="headersList">
      <div class="headerList-title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-diandeng"></use>
        </svg>
        <p>{{ $t('allItem') }}</p>
      </div>
      <div class="headersDatas">
        <div class="headersData" v-for="(item,index) in headerData"  :key="item.id">
          <div class="headersData-title">
            <p>{{item.title}}</p>
            <div class="fold" @click="fold(index)">
              <svg v-if="item.fold" class="icon" aria-hidden="true">
                <use xlink:href="#icon-shangjiantou"></use>
              </svg>
              <svg v-if="!item.fold" class="icon" aria-hidden="true">
                <use xlink:href="#icon-xiajiantou"></use>
              </svg>
            </div>
          </div>
          <draggable v-show="item.fold"
            class="headersData-box"
            :list="item.data"
            :group="{ name: 'tableHeader', pull: 'clone', put: false}"
            draggable = ".draggable"
            :sort="false"
          >
            <div class="headersData-list" v-for="header in item.data" :key="header.columnCode"
            :class="header.undraggable?'undraggable':'draggable'"
            @click="header.undraggable?deleteList(-1,header):add({'added':{'element':header}},true)"
            >
              {{ header[getTitleAll] ? header[getTitleAll] : header.columnName }}
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import {getCustomTableHeader  } from  "@/api/common/common"
  import {findAllPayoutHeaderInfo} from "@/api/wage/pay";
import { keys } from 'xe-utils/methods';
  export default {
    props: {
      headerList:{
        type:Array,
        default: () => (
          []
        )
      },
      reportType: {//员工收入明细表或员工收入汇总表
        type: String,
        default: ''
      },
      paramFromSyn:{},
    },
    data(){
      return{
        headerData:[],
        loading:false,
        paramFromSyn:{}
      }
    },
    components: {
      draggable,
    },
    created(){
      // 加载数据
      this._getInfoItem();
    },
    mounted(){

    },
    methods:{
      _getInfoItem(){
        let param = {
          reportType: this.reportType,
          cusId: this.$userInfo.cusId,
          ...this.paramFromSyn
        };
        this.loading = true;
        findAllPayoutHeaderInfo(param).then(res=>{
          this.loading = false;

          this.headerData = res.data.data.allItmeList;//自定义表头数据信息所有的，带分类集的
          this.headerList = res.data.data.custItmeList;//自定义表头信息集，用户配置过得

          console.log('全集',this.headerData)
          console.log('用户集',this.headerList)
          for(var i = 0; i < this.headerData.length; i++){
            this.$set(this.headerData[i],"fold",true)
            for (let j in this.headerData[i].data) {
              let data = this.headerData[i].data[j];
              for (let k in this.headerList) {
                let temp = this.headerList[k];
                if(temp.columnCode == data.columnCode){
                  this.headerData[i].data[j]['undraggable'] = true;
                  break;
                }
              }
            }
          }
          this.$emit('update:headerList', this.headerList);//更新父的表头信息列
        })
      },
      fold(inx){
        this.$set(this.headerData[inx],'fold',!this.headerData[inx].fold)
      },
      add:function(e,t){
        if(e.added){
          const id = e.added.element.id;
          const parentId = e.added.element.itemSetId;
          const index = e.added.newIndex;
          for (var i = 0; i < this.headerData.length; i++) {
            let k = true;
            for(var j = 0; j < this.headerData[i].data.length; j++){
              if(this.headerData[i].data[j].id === id){
                this.$set(this.headerData[i].data[j],'undraggable',true)
                k = false;
                break;
              }
            }
            if(!k){
              break;
            }
          }
          if(t){//点击时 触发
            this.headerList.push(e.added.element)//点击 追加
          }else{
            this.headerList.splice(index,1,e.added.element)//拖拽 插入
          }
          this.$emit('update:headerList', this.headerList);
        }
      },
      deleteList(inx,item){
        if(inx == -1){
          //下方点击删除 需要找到在上方列表的序号
          for (let i in this.headerList) {
            let temp = this.headerList[i];
            if(temp.columnCode == item.columnCode){
              inx = i;
              break;
            }
          }
        }
        console.log('=============',item)
        const parentId = this.headerList[inx].itemSetId;
        const columnCode = this.headerList[inx].columnCode;
        // 当值是1 时 为固定不能删除
        const isSys = this.headerList[inx].isSys;
        if(isSys){
          console.log("固定不能删除")
          this.$message.warning('系统固定项不能删除')
          return ;
        }
        for (var i = 0; i < this.headerData.length; i++) {
          let k = true;
          for(var j = 0; j < this.headerData[i].data.length; j++){
            if(this.headerData[i].data[j].columnCode === columnCode){
              this.$set(this.headerData[i].data[j],'undraggable',false)
              this.headerList.splice(inx, 1);
              k = false;
              break;
            }
          }
          if(!k){
            break;
          }
        }

        this.$emit('update:headerList', this.headerList);
      }
    },
    computed: {
      isEn() {
        return localStorage.getItem('lang') === 'en';
      },
      getTitleAll() {
        return this.isEn ? 'itemNameEn' : 'columnName';
      },
      getTitleCust() {
        return this.isEn ? 'itemEnName' : 'itemName';
      },
    }
  };
</script>

<style scoped>
  .headerList{
    border-bottom:1px solid #cccccc;
    padding-bottom: 20px;
  }
.headerList-title{
  color:#FFC000;
  font-size: 16px;
  display: flex;
  line-height: 40px;
  align-items: center;
  padding-left: 20px;
}
.headerList-title p{
  color:#999999;
  font-size: 14px;
  margin-left: 6px;
}
  .headerList-box{
    background-color: #FFFBE6;
    padding:20px 20px 10px 20px;
  }
.headerList-box .list-group{
  display: flex;
  flex-wrap: wrap;
}
  .headerList-box .list-group div{
    height: 30px;
    border:1px solid #ffc000;
    background-color: #fff;
    padding:0 10px;
    line-height: 30px;
    border-radius: 4px;
    color:#000000;
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: move;
  }
.headerList-box div div svg{
  margin-left: 10px;
  color:#ff9600;
  cursor: pointer;
}
  .headersData-title{
    background-color: #F4F4F4;
    border-radius: 2px;
    padding-left: 20px;
    color:#999999;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px
  }
  .fold{
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }
  .headersData-box{
    display: flex;
    padding:20px 20px 10px 20px;
    flex-wrap: wrap;
  }
  .headersData-list{
    background-color: #f4f4f4;
    font-size: 14px;
    color:#000000;
    line-height: 30px;
    padding: 0 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: move;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }
  .headersData{
    margin-bottom: 10px;
  }
  .undraggable{
    background-color: #FFA729;
    color:#ffffff;
  }
</style>
